// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2XHFH","footer":"ModalUpdate_footer__RAZqU"};